import React from 'react';
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'underscore';

import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acBilet } from '../actions/acBilet';
import { acConSizeChange } from '../actions/acConSizeChange';

class StatisticiNumere extends React.Component {

    constructor() {
        super();
        this.state = {
            statisticiNumere: undefined,
            pair: undefined,
            showHide: false,
            biletTab: undefined
        };
    }

    componentDidMount() {
        var statistici = {
            ruta: this.props.appProps.ruta,
            reducer: 'STATISTICI',
            request: 'get_stat_rounds',
            value: 'lottery_prefix=' + this.props.loterii[0].prefix,
            error: '6000',
            extra: this.props.loterii[0].name_lot.replace(/ /g, "_"),
            newParam: this.props.sessionParam
        }

        this.props.acAxiosRequest(statistici);

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.nrStatistici && prevProps.nrStatistici) {
            if (this.props.nrStatistici.extra !== prevProps.nrStatistici.extra) {
                if (this.state.statisticiNumere !== undefined && this.state.pair !== undefined && this.props.nrStatistici.numbers.status === "success" && this.props.nrStatistici.pairs1.status === "success" && this.props.nrStatistici.pairs2.status === "success") {
                    this.statistici(this.state.statisticiNumere, this.state.pair)
                } else {
                    this.setState({
                        statisticiNumere: undefined,
                        pair: undefined,

                    })
                }
            }
        }
        if (prevProps.biletTab && this.props.biletTab) {
            if (this.props.biletTab !== prevProps.biletTab) {
                // if (_.findWhere(this.props.bilete, { position: this.props.biletTab })) {
                this.setState({
                    statisticiNumere: undefined,
                    pair: undefined,

                })
                // }
            }
        }
    }
    statistici(val, pair) {
        var nrStatistici = []
        var frecventa = []
        var rundaVal = this.props.rundaSelectata

        var valBiletNou = {
            idRunda: rundaVal.id,
            roundUnique: rundaVal.round_unique,
            numereArr: nrStatistici,
            timeStart: rundaVal.timeStart,
            numeLot: rundaVal.selectedLot,
            gameType: this.props.activeLot.game_type,
            odds: this.props.activeLot.odds,
            miza: 0,
            currency: this.props.defaultVal.currency,
            checked: [1],
            cotaTot: 0,
            castigEv: 0,
            sum: [],
            coteFixe: [],
            position: this.props.biletTab,
            valid: true,
            pariat: false,
            mesaj: '',
            future: 0,
            futureSuccess: 0,
            futureError: 0,
            futureErrorRounds: [],
            futureMessage: [this.props.multiLang.biletePariate.txt, this.props.multiLang.bileteEsuate.txt],
            nrFavorite: null
        }

        if (val === '5perechi frecvente') {
            var string = this.props.nrStatistici.pairs1.statistics[pair - 1].string
            var arrNr = string.split(',')
            frecventa.push(this.props.nrStatistici.pairs1.statistics[pair - 1].frequency)
            for (var i = 0; i < arrNr.length; i++) {
                nrStatistici.push(parseInt(arrNr[i], 10))
            }
        } else if (val === '5perechi consecutive') {
            string = this.props.nrStatistici.pairs2.statistics[pair - 1].string
            frecventa.push(this.props.nrStatistici.pairs2.statistics[pair - 1].max_consec)
            arrNr = string.split(',')
            for (i = 0; i < arrNr.length; i++) {
                nrStatistici.push(parseInt(arrNr[i], 10))
            }
        } else if (val === '5frecvente') {
            for (var j = 0; j < 5; j++) {
                nrStatistici.push(this.props.nrStatistici.numbers.statistics[j].number)
                frecventa.push(this.props.nrStatistici.numbers.statistics[j].frequency)
            }
        } else if (val === '5rare') {
            for (j = 5; j < 10; j++) {
                nrStatistici.push(this.props.nrStatistici.numbers.statistics[j].number)
                frecventa.push(this.props.nrStatistici.numbers.statistics[j].frequency)
            }
        }

        this.setState({
            statisticiNumere: val,
            pair: pair,
            numere: nrStatistici,
            frecventa: frecventa,
            biletTab: this.props.biletTab

        })
        if (this.props.bilete !== null) {
            var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            if (findBilet && findBilet.numeLot === this.props.activeLot.name_lot) {
                var values = {
                    position: findBilet.position,
                    statisticsNumber: nrStatistici,
                    odds: this.props.activeLot.odds
                }
                this.props.acBilet(['biletStatisticsNumere', values])
            } else if (findBilet === undefined && this.props.appProps.colMid === 'Mid1ConNr') {
                this.props.acBilet(['biletNou', valBiletNou])
            }
        } else if (this.props.appProps.colMid === 'Mid1ConNr') {
            this.props.acBilet(['biletNou', valBiletNou])
        }
        // var rundaVal = this.props.rundaSelectata

        // var valBiletNou = {
        //     idRunda: rundaVal.id,
        //     roundUnique: rundaVal.round_unique,
        //     numereArr: nrStatistici,
        //     timeStart: rundaVal.timeStart,
        //     numeLot: rundaVal.selectedLot,
        //     gameType: this.props.activeLot.game_type,
        //     odds: this.props.activeLot.odds,
        //     miza: 0,
        //     currency: this.props.defaultVal.currency,
        //     checked: [1],
        //     cotaTot: 0,
        //     castigEv: 0,
        //     sum: [],
        // coteFixe: [],
        //     position: this.props.biletTab,
        //     valid: true,
        //     pariat: false,
        //     mesaj: ''
        // }
        // this.props.acBilet(['biletNou', valBiletNou])
    }

    activeClass(val, pair) {
        if (pair !== '0') {
            if ((pair === this.state.pair) && (val === this.state.statisticiNumere)) {
                return 'active'
            }
        } else if (val === this.state.statisticiNumere) {
            return 'active'
        }
    }

    numereFrecvente(val) {
        var numere = []
        var frecvente = []
        if ((this.state.numere !== undefined) && (this.state.frecventa !== undefined) && (val === this.state.statisticiNumere)) {

            for (var i = 0; i < this.state.numere.length; i++) {
                numere.push(<div key={i} className="numere">{this.state.numere[i]}</div>)
            }

            for (var j = 0; j < this.state.frecventa.length; j++) {
                frecvente.push(
                    <div key={j} className="frecvente">{this.state.frecventa[j]}</div>
                )
            }

            if ((val === '5frecvente') || (val === '5rare')) {
                var frec =
                    <div className="con-frecvente">
                        <span>{this.props.multiLang.freq.txt}</span>
                        {frecvente}
                    </div>
                var nr =
                    <div className="con-numere">
                        <span>{this.props.multiLang.nb.txt}</span>
                        {numere}
                    </div>


            } else {
                var numere_per = this.state.numere[0] + ', ' + this.state.numere[1]
                frec =
                    <div className="con-frecvente">
                        <span>{this.props.multiLang.freq.txt}</span>
                        {frecvente}
                    </div>
                nr =
                    <div className="con-numere">
                        <span>{this.props.multiLang.nb2.txt}</span>
                        <div className="numere-per">{numere_per}</div>
                    </div>

            }
            return (
                <div className="con-connumere">
                    {nr}
                    {frec}
                </div>
            )
        } else {
            return (<div></div>)
        }
    }
    showHide() {
        const currentState = this.state.showHide;
        this.setState({ showHide: !currentState });

        var dimensions = ReactDOM.findDOMNode(this).getBoundingClientRect();
        this.props.acConSizeChange({ colSt: dimensions.height })
    }
    render() {
        if (this.props.nrStatistici !== null && this.props.nrStatistici.numbers.status === 'success' && this.props.nrStatistici.pairs2.status === 'success' && this.props.nrStatistici.pairs1.status === 'success') {
            return (
                <div className="con-statistici">
                    <div className={'stat-title ' + this.state.showHide}
                        onClick={this.showHide.bind(this)}><div className="arrow"></div>{this.props.multiLang.nrStat.txt}
                        <img id="info-img" src="img/icon/info.svg" alt="" title={this.props.multiLang.statInfo.txt} />
                        <p className="statInfo">{this.props.multiLang.statInfo.txt}</p>
                    </div>

                    <div className="con-simple">
                        <div className={'statistici sta1 ' + this.activeClass('5rare', '0')}
                            onClick={this.statistici.bind(this, '5rare', '0')} >
                            <div className="bullet"></div>
                            <div className="stat_nb">{this.props.multiLang.rareNb.txt}</div>
                        </div>
                        <div ref="rare-info">{this.numereFrecvente('5rare')}</div>

                        <div className={'statistici sta2 ' + this.activeClass('5frecvente', '0')}
                            onClick={this.statistici.bind(this, '5frecvente', '0')} >
                            <div className="bullet"></div>
                            <div className="stat_nb">{this.props.multiLang.freqNb.txt}</div>
                        </div>
                        <div ref="frecvente-info">{this.numereFrecvente('5frecvente')}</div>

                        <div className={'statistici sta3 ' + this.activeClass('5perechi frecvente', '0')} >
                            <div
                                className={'bullet ' + this.activeClass('5perechi frecvente', '1')}
                                onClick={this.statistici.bind(this, '5perechi frecvente', '1')}></div>
                            <div className="stat_nb">
                                <div>{this.props.multiLang.freqPairs.txt}</div>
                                <div className="pairs-options">
                                    <div
                                        className={this.activeClass('5perechi frecvente', '1')}
                                        onClick={this.statistici.bind(this, '5perechi frecvente', '1')}>1</div>
                                    <div
                                        className={this.activeClass('5perechi frecvente', '2')}
                                        onClick={this.statistici.bind(this, '5perechi frecvente', '2')}>2</div>
                                    <div
                                        className={this.activeClass('5perechi frecvente', '3')}
                                        onClick={this.statistici.bind(this, '5perechi frecvente', '3')}>3</div>
                                    <div
                                        className={this.activeClass('5perechi frecvente', '4')}
                                        onClick={this.statistici.bind(this, '5perechi frecvente', '4')}>4</div>
                                    <div
                                        className={this.activeClass('5perechi frecvente', '5')}
                                        onClick={this.statistici.bind(this, '5perechi frecvente', '5')}>5</div>
                                </div>
                            </div>
                        </div>
                        <div ref="perechi-frecvente-info">{this.numereFrecvente('5perechi frecvente')}</div>

                        <div className={'statistici sta4 ' + this.activeClass('5perechi consecutive', '0')}>
                            <div
                                className={'bullet ' + this.activeClass('5perechi consecutive', '1')}
                                onClick={this.statistici.bind(this, '5perechi consecutive', '1')} ></div>
                            <div className="stat_nb">
                                <div>{this.props.multiLang.freqConsPairs.txt}</div>
                                <div className="pairs-options">
                                    <div
                                        className={this.activeClass('5perechi consecutive', '1')}
                                        onClick={this.statistici.bind(this, '5perechi consecutive', '1')}>1</div>
                                    <div
                                        className={this.activeClass('5perechi consecutive', '2')}
                                        onClick={this.statistici.bind(this, '5perechi consecutive', '2')}>2</div>
                                    <div
                                        className={this.activeClass('5perechi consecutive', '3')}
                                        onClick={this.statistici.bind(this, '5perechi consecutive', '3')}>3</div>
                                    <div
                                        className={this.activeClass('5perechi consecutive', '4')}
                                        onClick={this.statistici.bind(this, '5perechi consecutive', '4')}>4</div>
                                    <div
                                        className={this.activeClass('5perechi consecutive', '5')}
                                        onClick={this.statistici.bind(this, '5perechi consecutive', '5')}>5</div>
                                </div>
                            </div>
                        </div>
                        <div ref="perechi-consecutive-info">{this.numereFrecvente('5perechi consecutive')}</div>
                    </div>

                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        serverTime: state.serverTime,
        activeLot: state.activeLot,
        appProps: state.appProps,
        nrStatistici: state.nrStatistici,
        bilete: state.bilete,
        biletTab: state.biletTab,
        defaultVal: state.defaultVal,
        rundaSelectata: state.rundaSelectata,
        multiLang: state.multiLang,
        loterii: state.loterii,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acBilet: acBilet,
        acConSizeChange: acConSizeChange
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(StatisticiNumere);